import React from "react"
import SubBlogPostStyle from "./SubBlogPostStyle.module.styl"
import Image from "gatsby-image"
import { Link } from "gatsby"

const SubBlogPost = ({ subBlog }) => {
  return (
    <Link
      key={subBlog.id}
      to={`/${subBlog.slug}/`}
      className={SubBlogPostStyle.image_holder}
    >
      <Image
        alt="blog-image"
        className={SubBlogPostStyle.image}
        fluid={subBlog.mainImage.fluid}
      />
      <p className={SubBlogPostStyle.title}>{subBlog.title}</p>
    </Link>
  )
}

export default SubBlogPost
